import styled from 'styled-components';

export {
  Container,
  LeftPanel,
  RightPanel,
  EmptyState,
  NewButton,
  ListSummary,
} from '../dispositions/styled-comps';

export {
  FormContainer,
  FormHeader,
  FormTitle,
  Field,
  Label,
  Input,
  TextArea,
  ButtonRow,
  SaveButton,
  DeleteButton,
  SecondaryButtonRow,
  ModalOverlay,
  ModalBox,
  ModalTitle,
  ModalText,
  ModalActions,
  ModalCancelButton,
  ModalConfirmDeleteButton,
  ScopeChipsContainer,
  ScopeChip,
  ScopeChipRemove,
  ScopeDropdownWrapper,
  ScopeDropdownTrigger,
  ScopeDropdownMenu,
  ScopeDropdownItem,
  DropdownArrow,
  DropdownEmptyItem,
} from '../dispositions/styled-comps';

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  font-size: 13px;
  color: ${({ $selected }) => ($selected ? '#0177ff' : '#2b2b2b')};
  background: ${({ $selected }) => ($selected ? '#E8F0FE' : 'transparent')};
  cursor: pointer;
  border-left: 3px solid ${({ $selected }) => ($selected ? '#0177ff' : 'transparent')};

  > .name {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover {
    background: ${({ $selected }) => ($selected ? '#E8F0FE' : '#f5f5f5')};
  }
`;

export const TagInput = styled.input`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #0177ff;
  }
`;
